module.exports = __webpack_public_path__ + "assets/img/Back_004.52c10582-ps.jpg";